import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MethodApi, PersonApi } from '../+api';
import { MethodInterface } from '../+models';
import { MethodServiceInterface } from './method.service.interface';

@Injectable({
  providedIn: 'root',
})
export class MethodService implements MethodServiceInterface {
  constructor(private personApi: PersonApi) {}

  private methodApi = inject(MethodApi);

  getAllForUser(userId: number): Observable<MethodInterface[]> {
    return this.personApi.getData(userId, 'methods').pipe(map((res: { methods: MethodInterface[] }) => res.methods));
  }

  getAllowedMethodIds(userId: number): Observable<number[]> {
    return this.personApi.getData(userId, 'allowedMethods').pipe(map((res: any) => res.allowedMethods));
  }

  getMethods$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: MethodInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.methodApi.getMethods(params);
  }

  public createMethod(method: MethodInterface): Observable<MethodInterface> {
    return this.methodApi.createMethod(method);
  }

  public updateMethod(method: MethodInterface): Observable<MethodInterface> {
    const params = new HttpParams({
      fromObject: {
        id: method.id?.toString(),
      },
    });
    return this.methodApi.updateMethod(params, method);
  }

  public deleteMethod(method: MethodInterface): Observable<boolean> {
    return this.methodApi.deleteById(method.id);
  }
}
